<template>  
<v-card flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
      <v-card flat class="v-card__container">
        <v-card-title class="no-margins">
          <h4>Användare</h4>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            prepend-icon="$sl-search"
            placeholder="Sök i listan"
            single-line
            @keydown.enter="doSearch()"
            hide-details
          ></v-text-field>
        </v-card-title>

        <!-- <div class="justify-end d-flex mt-4">
          <v-btn @click="doSearch()">Sök</v-btn>
        </div> -->
      </v-card>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="users"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalRows"
      :items-per-page="itemsPerPage"
      :search="search"
      item-key="id"
      class="clickable mx-6 mt-6"
      @click:row="clickUser"
    >
      <!-- User last name header -->
      <template slot="item.lastName" slot-scope="props">
        {{ props.item.firstName }} {{ props.item.lastName }}
      </template>
      <!-- User support header -->
      <template slot="item.supportUser" slot-scope="props">
        <boolean-column :isSet="props.item.supportUser" />
      </template>
      <!-- User login email header -->
      <template slot="item.loginByEmail" slot-scope="props">
        <boolean-column :isSet="props.item.loginByEmail" />
      </template>
      <!-- User login bank id header -->
      <template slot="item.loginByBankId" slot-scope="props">
        <boolean-column :isSet="props.item.loginByBankId" />
      </template>
      <!-- User email header -->
      <template slot="item.email" slot-scope="props">
        <email-column :email="props.item.email" />
      </template>

      <template slot="item.action" slot-scope="props">
        <div style="text-align: right;">
          <v-btn text class="mr-2 px-1" v-if="canDeleteUser" @click.prevent.stop="deleteUser(props.item)">
            <v-icon>$sl-delete</v-icon>Radera
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <v-btn absolute bottom right fab dark class="v-btn--add-on-list" @click="addUser()">
      <v-icon class="ml-1">$sl-add</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {pageSize} from '@/store/constants'
import BooleanColumn from '@/components/BooleanColumn.vue'
import EmailColumn from '@/components/EmailColumn.vue'
import Criterias from '@/components/mixins/Criterias'
import { CanIDo } from '@/components/mixins'
// @group Person
// Users component
export default {
  name: 'Users',

  mixins: [
    Criterias, 
    CanIDo,
  ],
  components: {
    BooleanColumn,
    EmailColumn
  },

  data: () => ({
    search: '',
    options: {},
    itemsPerPage: pageSize,
    totalRows: 0,
    users: [],
    headers: [
      {
        text: 'Namn',
        value: 'lastName'
      },
      {
        text: 'Ort',
        value: 'city'
      },
      {
        text: 'Mobil',
        value: 'mobilephone'
      },
      {
        text: 'E-post',
        value: 'email'
      },
      {
        text: 'Inloggning E-post',
        value: 'loginByEmail',
        sortable: false
      },
      {
        text: 'Inloggning BankId',
        value: 'loginByBankId',
        sortable: false
      },
      { 
        text: '',
        value: 'action', 
        sortable: false
      }
    ],
    //- For fragment criterias
    criteria: {},
    doneInitialSearch: false
  }),

  asyncComputed: {
    canDeleteUser(){
      return this.canIDo('user', 'delete');
    },
  },

  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('currentuser', ['currentUser'])
  },

  created() {
    // @vuese
    //- Get criteria from url hash fragment
    const locationCriteria = this.getCriteriaFromLocation('c')
    // @vuese
    //- Set values if we have a criteria
    if (locationCriteria) {
      this.criteria = locationCriteria
      this.search = this.criteria.search
      this.options = {
        page: this.criteria.page,
        itemsPerPage: this.criteria.pageSize,
        sortBy: [this.criteria.sortBy],
        sortDesc: [this.criteria.sortDesc]
      }
    }
  },

  watch: {
    options: {
      handler() {
        this.fetchUsers()
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('user', ['setSelectedUser']),

    addUser() {
      console.log('Users - addUser')
      this.$router.push('/users/new')
    },

    doSearch() {
      if (this.options.page > 1) {
        this.options.page = 1
      } else {
        this.fetchUsers()
      }
    },
    /**
     * @vuese
     * Used to fetch Users f
     * @arg The arguments are the criteries comming from data tables
     */
    fetchUsers() {
      console.log('Users - fetchUsers')

      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      const startAt = (page - 1) * this.itemsPerPage

      this.criteria = {
        page: page,
        startAt: startAt,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
        search: this.search,
        pageSize: this.itemsPerPage
      }

      API.listUsers(this.criteria)
        .then(response => {
          // @vuese
          //- Set Users criteries to local store
          this.setCriteriaToLocation('c', this.criteria)
          this.users = response.data.rows
          this.totalRows = response.data.count
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    async clickUser(item) {
      await this.setSelectedUser(null)
      this.$nextTick(() => this.$router.push('/users/' + item.id).catch(()=>{}));
    },

    async deleteUser(user) {
      if (user.id === this.currentUser.id) {
        this.$events.fire('showError', 'Du kan inte radera dig själv.')
        return
      }

      const res = await this.$dialog.confirm({
        text: 'Radering av användare går inte att ångra.',
        title: 'Vill du verkligen radera denna användare?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) {
        return
      }

      API.deleteUser(user.id)
        .then(() => {
          this.$events.fire('showInfo', 'Användaren raderad.')
          this.fetchUsers();
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    }
  }
}
</script>

<style>
table.v-table thead th {
  white-space: normal;
}
</style>